import './index.scss'
import projects from '../../../data/projects'

const ConcurrentRecordDetail = () => {
	const project = projects.find((p) => p.slug === 'concurrent-record-database') || {}

	return (
		<main className="project-detail">
			<div className="site-container">
				<section className="project-detail__hero">
					<h1>{project.title}</h1>
                    <h3>{project.role} @ {project.organisation} ({project.timeline})</h3>
					{project.skills && (
						<ul className="project-detail__skills">
							{project.skills.map((s) => (
								<li key={s}>{s}</li>
							))}
						</ul>
					)}
				</section>

				<section className="project-detail__content">
				<h3>Project summary</h3>
				<p>{project.description}</p>

				{/* skills shown under the title */}

				<h3>Notes</h3>
				<p>
					Consider adding a short video or screenshots to better present the UI and concurrency behaviours.
				</p>
				</section>
			</div>
		</main>
	)
}

export default ConcurrentRecordDetail
